import React from 'react';
import Section from '@latitude/section';
import { Typography } from '../Typography';
import './_image_grid.scss';

const ImageGrid = ({ title, images = [], maxCols = 5 }) => {
  return (
    <div className="image-grid">
      <Section className="image-grid__section">
        {title && (
          <Typography.H4 className="image-grid__title">{title}</Typography.H4>
        )}
        <div
          className="image-grid__inner"
          role="list"
          style={{ gridTemplateColumns: `repeat(${maxCols}, 1fr)` }}
        >
          {images.map((img, idx) => (
            <div key={idx} className="image-grid__item" role="listitem">
              <img
                src={img.src}
                alt={img.alt || ''}
                loading="lazy"
                className="image-grid__img"
              />
            </div>
          ))}
        </div>
      </Section>
    </div>
  );
};

export default ImageGrid;
